export * from "./Teach";
export * from "./ITeachProps";
